import { 
	PhoenixFeature, 
	PhoenixUser,
	PhoenixDeployment
} from 'phoenix/domain';
import { 
	PhoenixToggleService, 
	FeatureService 
} from 'phoenix/services';

export type ToggleSubject = PhoenixUser|PhoenixDeployment;
type FeatureDescriptor = Pick<PhoenixFeature, 'FeatureName' | 'FeatureNamespace' | 'FeatureDescription'>;

export abstract class FeatureToggle {
	public isToggledOn = false;
	public readonly name:string = this.source.FeatureName;
	public readonly namespace:string = this.source.FeatureNamespace;
	public readonly description:string = this.source.FeatureDescription;

	/**
	 * The fully-qualified name of the feature.
	 */
	public get fullName() {
		let name = this.name;
		if(this.namespace){
			name = `${this.namespace}/${this.name}`;
		}

		return name;
	}

	constructor(
		protected source:FeatureDescriptor
	){
	}

	public abstract save():ng.IPromise<void>;
}

/**
 * Represents a feature toggle whose backing DTO encapsulates its own hypermedia URIs for toggling.
 */
export class AgnosticToggle extends FeatureToggle {
	constructor(
		private pxFeatureService:FeatureService,
		protected source:PhoenixFeature
	){
		super(source);
	}

	public save(){
		return this.pxFeatureService.toggleFeature(this.source, this.isToggledOn);
	}	
}

export class CurrentUserToggle extends FeatureToggle {
	constructor(
		private pxPhoenixToggleService:PhoenixToggleService,
		source:FeatureDescriptor
	){
		super(source);
	}

	public save(){
		return this.pxPhoenixToggleService.set(this.fullName, this.isToggledOn);
	}
}

export class UserToggle extends FeatureToggle {
	constructor(
		private pxFeatureService:FeatureService,
		source:FeatureDescriptor,
		protected user:PhoenixUser,
		
	){
		super(source);	
	}

	public save(){
		return this.pxFeatureService.user.toggle(this.user, this.namespace, this.name, this.isToggledOn);		

	}
}

export class DeploymentToggle extends FeatureToggle {
	constructor(
		private pxFeatureService:FeatureService,
		source:FeatureDescriptor,
		protected deployment:PhoenixDeployment,
	){
		super(source);	
	}

	public save(){
		return this.pxFeatureService.deployment.toggle(this.deployment, this.namespace, this.name, this.isToggledOn);
	}
}


// WEBPACK FOOTER //
// ./src/sharebase/domain/feature.ts